import { IDataGridOptions, IColDef } from 'components/common/DataGridDevEx/DataGrid.properties';

import {
  createActions, asyncInitialState,
  IDataAction,
  IExtendedState
} from '../../utils';

export interface ISettingsAttributesData {
  selected: any;
  gridOptions: IDataGridOptions;
  Columns: IColDef[];
}

export interface ISettingsAttributesState extends IExtendedState<ISettingsAttributesData> {
}

export const { types, actions } = createActions(
  {
    setSelected: (row) => ({ row }),
    asyncs: {

    }
  },
  'supplierSettingsAttributes');

const initialState = asyncInitialState<ISettingsAttributesData>({
  selected: null,
  gridOptions: {
    doubleClickActionTab: '',
    suppressEditDeleteInContextMenu: true,
    rowModelType: 'serverSide',
    cacheBlockSize: 10,
    maxBlocksInCache: 5,
    enableMasterDetailModel: true,
    detailCellRenderer: 'CommentAreaRenderer',
    detailCellRendererParams: {
      getDetailRowData: function (params: { data?: { Comment?: string } }): any {
        return { commentData: params.data.Comment };
      }
    }
  },
  Columns: [
    { headerName: 'Attribute set', field: 'AttributeSet', minWidth: 200, suppressSorting: true },
    { headerName: 'Attribute code', field: 'AttributeCode', minWidth: 200 },
    { headerName: 'Description', field: 'Description', minWidth: 300, suppressSorting: true },
  ]
});

export default (state: ISettingsAttributesState = initialState, action: IDataAction): ISettingsAttributesState => {
  switch (action.type) {
    case types.setSelected:
      const selected = action.data.row;

      return {
        ...state,
        data: {
          ...state.data,
          selected: selected
        }
      };
    default:
      return state;
  }
};

export const selectors = ({
  selected: (state: { supplierEnquiry: { settings: { attributes: ISettingsAttributesState } } }) => state.supplierEnquiry.settings.attributes.data.selected,
  gridOptions: (state: { supplierEnquiry: { settings: { attributes: ISettingsAttributesState } } }) => state.supplierEnquiry.settings.attributes.data.gridOptions,
  columns: (state: { supplierEnquiry: { settings: { attributes: ISettingsAttributesState } } }) => state.supplierEnquiry.settings.attributes.data.Columns,
});
